export default "__VITE_ASSET__3kKW7aXw__"